export const news = [
  {
    title:
      "Власти Китая решили провести масштабную проверку устойчивости экономики, пишет The Guardian.",
    text: "Как утверждают источники издания, с помощью стресс-теста китайское руководство пытается выработать стратегию на случай, если в отношении КНР введут санкции, подобные тем, которым подверглась Россия.",
    time: 1651671992000,
    isApproved: true,
  },
  {
    title:
      "Президент Франции Эмманюэль Макрон и премьер Индии Нарендра Моди встретились в Париже. ",
    text: "Как сообщили в МИД Индии, в ходе переговоров стороны достигли «широкого понимания позиций друг друга» по ситуации на Украине. Господин Моди начал свое европейское турне в понедельник, 2 мая.",
    time: 1651599192000,
    isApproved: true,
  },
  {
    title: "«Северный поток-2» развернется в Россию",
    text: "Германия в случае возобновления проекта «Северный поток-2», который заморожен с осени 2021 года, не сможет использовать его мощности более чем на 50% вплоть до 2028 года, сообщил «Газпром».",
    time: 1649007192000,
    isApproved: true,
  },
  {
    title: "Американские потребители уходят в отрыв",
    text: "После того как волна «омикрона» пошла на спад, американцы начали возвращаться к допандемийному образу жизни. Компании, специализирующиеся на путешествиях или массовых мероприятиях.",
    time: 1646328792000,
    isApproved: true,
  },
  {
    title: "«Динамо» разгрузило лидеров в «Ак Барс»",
    text: "Спустя несколько дней после завершения очередного чемпионата в КХЛ состоялась сделка, громче которой в нынешнем межсезонье, возможно, уже не будет.",
    time: 1643909592000,
    isApproved: false,
  },
];
